import { render } from "./VersionsModal.vue?vue&type=template&id=8d12069a"
import script from "./VersionsModal.vue?vue&type=script&lang=js"
export * from "./VersionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__